import React from 'react';
import { FrownOutlined } from '@ant-design/icons';

const NoData = () => {
  return (
    <div>
      <FrownOutlined /> Нет данных
    </div>
  );
};

export default NoData;
